import { createTheme } from '@mui/material/styles';

const baseTheme = createTheme({
	palette: {
		type: 'light',
		background: {
			default: '#fff',
			darker: '#a5a291'
		},
		header: {
			default: '#2f56a9'
		},
		disabled: {
			light: '#e5e5e5',
			main: '#f9f9f9'
		},
		success: {
			main: '#e6e263'
		},
		error: {
			main: '#cd5c5c'
		},
		warning: {
			main: '#cbcb04'
		},
		common: {
			white: '#ffffff',
			black: '#000000',
			gray: '#ccc'
		},
		primary: {
			main: '#002856'
		},
		secondary: {
			main: '#6D7EA5'
		},
		divider: '#e0e0e0'
	}
});

export default baseTheme;
